export default {
    swiperLoaded: false,
}